export default __webpack_public_path__ + "static/media/apple-logo.e3cb2424.webp";